// External capital is nominal, net of acquisition/sale taxes, and invested at month start.
export const SWR_CONTRIBUTION_VERSION = 'nominal-net-month-start-v1';
export const SWR_MAX_CONTRIBUTIONS = 100;

export function normalizeSWRContributions(events = [], years = 40) {
  if (!Array.isArray(events) || events.length > SWR_MAX_CONTRIBUTIONS) {
    throw new Error(`Gli apporti devono essere un elenco con al massimo ${SWR_MAX_CONTRIBUTIONS} voci.`);
  }
  return events.map((event, index) => {
    if (!event || !Number.isInteger(event.month) || event.month < 1 || event.month > years * 12) {
      throw new Error(`Apporto ${index + 1}: scegli un mese dall'inizio del decumulo fino al mese ${years * 12}.`);
    }
    if (typeof event.amount !== 'number' || !Number.isFinite(event.amount) || event.amount <= 0 || event.amount > 1e15) {
      throw new Error(`Apporto ${index + 1}: l'importo nominale netto deve essere positivo e non superiore a 1.000.000.000.000.000 €.`);
    }
    if (event.label != null && (typeof event.label !== 'string' || event.label.length > 100)) {
      throw new Error(`Apporto ${index + 1}: la descrizione può contenere al massimo 100 caratteri.`);
    }
    return { month: event.month, amount: event.amount, label: (event.label || '').trim() };
  }).sort((a, b) => a.month - b.month);
}

export function buildSWRContributionAmounts(params) {
  if (!params.capitalContributions?.length) return null;
  const amounts = new Float64Array(params.yearsToSimulate * 12);
  params.capitalContributions.forEach(event => { amounts[event.month - 1] += event.amount; });
  return amounts;
}

export const formatSWRMonth = month => `anno ${Math.ceil(month / 12)}, mese ${(month - 1) % 12 + 1}`;
